import {Component, ViewChild, ElementRef} from '@angular/core';

@Component({
  selector: 'ld-dynamic-div',
  templateUrl: './dynamic-div.template.html'
})
export class DynamicDivComponent {
  public textContent: string;
  public htmlContent: string | HTMLElement;

  @ViewChild('htmlContainer') htmlContainer: ElementRef;

  public setTextContent(content: string): void {
    this.textContent = content;
  }

  public setHtmlContent(content: string | HTMLElement = ''): void {

    if (!content) {
      this.htmlContainer.nativeElement.innerHTML = null;
    } else if (typeof content === 'string') {
      // If we are using inline style, innerHTML must be set
      // through the native element

      if (content.indexOf('<style>') === -1) {
        this.htmlContent = content;
      } else {
        this.htmlContainer.nativeElement.innerHTML = content;
      }
    } else {
      this.htmlContainer.nativeElement.innerHTML = content.outerHTML;
    }
  }
}
